import FooterExtra from "./footer-extra";
export default FooterExtra;
